<template class="full-height">
  <div class="member-container full-height">
    <!-- 審核 -->
    <el-dialog
      :top="'5%'"
      v-loading="listLoading"
      :visible.sync="dialogVisible"
      :title="'審核'"
      @closed="onDialogClosed"
    >
      <el-card class="box-card">
        <div style="padding: 20px; padding-bottom: 0" class="full-height">
          <div style="padding-bottom: 0">
            <el-form :inline="true">
              <el-form-item label="搜尋">
                <el-input
                  size="mini"
                  v-model="blackListQuery.qry"
                  placeholder="輸入帳號"
                  @keyup.enter.native="handleFilterBlackList"
                />
              </el-form-item>

              <el-form-item>
                <el-button
                  size="mini"
                  class="filter-item"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleFilterBlackList"
                >
                  搜尋
                </el-button>
                <el-button type="success" size="mini" @click="addData">新增</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div style="position: relative; height: 80%">
            <el-table
              :key="blackListTableKey"
              v-loading="listLoading"
              size="mini"
              :data="blackList"
              border
              fit
              highlight-current-row
              height="100%"
              @sort-change="sortChange"
            >
              <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
                <template slot-scope="{ row }">
                  <span>{{ row.id }}</span>
                </template>
              </el-table-column>

              <el-table-column
                :label="'帳號'"
                prop="userAccount"
                sortable="custom"
                align="center"
                width="200"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.userAccount }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="'建立時間'" prop="buildDate" align="center" width="200">
                <template slot-scope="{ row }">
                  <span>{{ row.buildDate }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" :label="'操作'" width="200">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    class="filter-item"
                    type="danger"
                    icon="el-icon-delete"
                    @click="saveData(scope.row)"
                  >
                    解除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination
            v-show="blackListTotal > 0"
            style="padding-top: 0"
            :total="blackListTotal"
            :page.sync="blackListQuery.page"
            :limit.sync="blackListQuery.limit"
            @pagination="getBlackList"
          />
        </div>
      </el-card>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入帳號"
              @keyup.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>
            <el-button type="danger" size="mini" @click="showBlackList">黑名單</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'文章'" prop="mapArticleID" align="left" width="130">
            <template slot-scope="{ row }">
              <a :href="openUrl + '/' + row.mapArticleID" target="_blank">
                <span style="color: rgb(64, 158, 255)">{{ row.articleTitle }}</span>
              </a>
            </template>
          </el-table-column>

          <el-table-column
            :label="'帳號'"
            prop="userAccount"
            sortable="custom"
            align="center"
            width="200"
          >
            <template slot-scope="{ row }">
              <span>{{ row.userAccount }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'姓名'" prop="userName" align="center" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.userName }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'評論內容'" prop="commentContent" align="center" width="400">
            <template slot-scope="{ row }">
              <span>{{ row.commentContent }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'建立時間'" prop="buildDate" align="center" width="200">
            <template slot-scope="{ row }">
              <span>{{ row.buildDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'刪除'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                icon="el-icon-delete"
                @click="deleteComm(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import {
  deleteComment,
  getCommentBlackList,
  getComments,
  saveCommentBlackList,
} from '@/api/tcSetting'

var defaultIntroductionFormData = {
  id: null,
  authorName: '',
  introduction: '',
  sort: 99,
  socialLinkList: [],
  fileInfo: [],
}

export default {
  name: 'Member',
  components: { Pagination },
  directives: { waves },
  data() {
    return {
      formLabelWidth: '120px',
      roleSettingObj: {},
      tableKey: 0,
      blackListTableKey: 0,
      blackList: null,
      blackListTotal: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 30,
        sort: '-BuildDate',
      },
      blackListQuery: {
        page: 1,
        limit: 30,
        sort: '-BuildDate',
      },
      dialogVisible: false,
      selectedUser: null,
      openUrl: '',
      //verifyResult: false,
    }
  },
  async created() {
    this.openUrl = process.env.VUE_APP_BASE_ARTICLE
    await this.getList()
  },
  methods: {
    async deleteComm(row) {
      let vm = this
      if (confirm(`確定刪除?\r\n`)) {
        vm.loadingHanlder(true)
        let resp = await deleteComment({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.loadingHanlder(false)
      }
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    addData() {
      this.$prompt('請輸入帳號', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      })
        .then(async ({ value }) => {
          if (value == null || value == '') {
            this.$message.error('請輸入帳號')
            return false
          }
          const loading = this.$loading({
            lock: true,
            text: '請稍後',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          await saveCommentBlackList({ userAccount: value, isRemove: false })
            .then(async resp => {
              console.log(resp)
              await this.getBlackList()
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            })
            .catch(() => {
              loading.close()
            })
        })
        .catch(() => {})
    },
    async saveData(row) {
      if (!confirm(`確定解除該帳號-【${row.userAccount}】?`)) {
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '請稍後',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      await saveCommentBlackList({
        userAccount: row.userAccount,
        isRemove: true,
      })
        .then(async resp => {
          console.log(resp)
          await this.getBlackList()
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success',
          })
        })
        .catch(() => {
          loading.close()
        })
    },
    async getList() {
      this.loadingHanlder(true)
      var res = await getComments(this.listQuery)
      this.list = res.data.data
      this.total = res.data.totalItemCount
      this.loadingHanlder(false)
    },
    async getBlackList() {
      await getCommentBlackList(this.blackListQuery)
        .then(response => {
          console.log(response)
          this.blackList = response.data.data
          this.blackListTotal = response.data.total
        })
        .catch()
    },
    async showBlackList() {
      await this.getBlackList()
      this.dialogVisible = true
    },
    onDialogClosed() {
      this.blackListQuery = {
        page: 1,
        limit: 30,
        sort: '-BuildDate',
      }
      this.dialogVisible = false
    },
    handleFilterBlackList() {
      this.blackListQuery.page = 1
      this.getBlackList()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
